import React, { useState } from "react";

const Grid = ({ grid, setGrid, cellColors }) => {
  const blackCells = [
    "1-0",
    "1-2",
    "1-3",
    "3-1",
    "3-3",
    "4-1",
    "4-3",
    "4-5",
    "4-7",
    "5-1",
    "5-3",
    "5-4",
    "6-0",
  ];
  // Handle user input in the grid and update the local state
  const handleInputChange = (e, rowIndex, colIndex) => {
    const newGrid = [...grid]; // Copy the grid from parent state
    newGrid[rowIndex][colIndex] = e.target.value.toUpperCase(); // Update the value at the specific cell
    setGrid(newGrid); // Update the parent state, which triggers a re-render
  };

  // Render box numbers (1 to 64) inside each cell
  const renderBoxNumbers = (rowIndex, colIndex) => {
    const boxNumber = rowIndex * 8 + colIndex + 1;
    return (
      <span
        style={{
          fontSize: "10px",
          fontWeight: "normal",
          position: "absolute",
          top: "5px",
          left: "5px",
        }}
      >
        {boxNumber}
      </span>
    );
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(8, 50px)",
        gridGap: "5px",
      }}
    >
      {grid.map((row, rowIndex) =>
        row.map((cell, colIndex) => {
          const cellId = `${rowIndex}-${colIndex}`; // Unique key for each cell
          const cellColor = cellColors[cellId]; // Get the color for this cell

          return (
            <div
              key={cellId}
              style={{
                width: "50px",
                height: "50px",
                border: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: blackCells.includes(cellId)
                  ? "black"
                  : cell === ""
                    ? "lightgray"
                    : cellColors[cellId] || "white",

                position: "relative",
              }}
            >
              {/* Display box number only in the top-left corner */}
              {renderBoxNumbers(rowIndex, colIndex)}

              {/* Input field for user to add letter */}
              <input
                type="text"
                maxLength="1"
                value={cell === "" ? "" : cell} // Show the value in the input field
                onChange={(e) => handleInputChange(e, rowIndex, colIndex)} // Update on change
                style={{
                  width: "100%",
                  height: "100%",
                  textAlign: "center",
                  fontSize: "18px",
                  backgroundColor: "transparent",
                  border: "none",
                  outline: "none",
                }}
              />
            </div>
          );
        }),
      )}
    </div>
  );
};

export default Grid;
